// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/less/app_blue.less
// module id = ./resources/assets/less/app_blue.less
// module chunks = 0